import { WorkspaceKeyValue } from 'features/globalSetup/types/workspaceKeyValue'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

export type KeyValueFreshStatus = Pick<WorkspaceKeyValue, 'id' | 'status'>

type Data = {
  workspaceKeyValues: KeyValueFreshStatus[]
}

export const useGetFreshStatusesForWorkspaceKeyValues = (): KeyValueFreshStatus[] => {
  const { data } = useQuery<never, Data>({
    options: {
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
    },
    query: gql`
      query getFreshStatusesForWorkspaceKeyValues {
        workspaceKeyValues {
          id
          status
        }
      }
    `,
  })

  return data?.workspaceKeyValues ?? []
}
